
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M3 6H16C16.55 6 17 5.55 17 5C17 4.45 16.55 4 16 4H3C2.45 4 2 4.45 2 5C2 5.55 2.45 6 3 6Z' fill='#323232'/><path d='M15.0001 17H17.0001V14H17.1801C17.8101 14 18.2801 13.42 18.1601 12.8L17.1601 7.8C17.0701 7.34 16.6601 7 16.1801 7H2.82007C2.34007 7 1.93007 7.34 1.84007 7.8L0.840074 12.8C0.720074 13.42 1.19007 14 1.82007 14H2.00007V19C2.00007 19.55 2.45007 20 3.00007 20H10.0001C10.5501 20 11.0001 19.55 11.0001 19V14H15.0001V17ZM9.00007 18H4.00007V14H9.00007V18Z' fill='#323232'/><path d='M22 18H20V16C20 15.45 19.55 15 19 15C18.45 15 18 15.45 18 16V18H16C15.45 18 15 18.45 15 19C15 19.55 15.45 20 16 20H18V22C18 22.55 18.45 23 19 23C19.55 23 20 22.55 20 22V20H22C22.55 20 23 19.55 23 19C23 18.45 22.55 18 22 18Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-add-business`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconAddBusiness

    ```js
    <b-new-b-icon-add-business />
    ```
</docs>


